import React, {useState} from 'react'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Container, Row, Col, Carousel, Nav, Card, Badge, Table } from 'react-bootstrap';
import img1 from '../Components/Images/Retail weighing/R1.jpg'
import img2 from '../Components/Images/Retail weighing/R2.jpg'
import img3 from '../Components/Images/Retail weighing/R3.png'
import img4 from '../Components/Images/Retail weighing/R4.jpg'


function Rongta() {

  const featureIcons = [
    { icon: "printer", text: "1 PRINTER RECEIPTS OR LABELS" },
    { icon: "printer-fill", text: "EASY LOADING RECEIPT PRINTER" },
    { icon: "vinyl", text: "LINERLESS DEP ON MODEL" },
    { icon: "display", text: "SEGMENTS LCD DISPLAY" },
    { icon: "display-fill", text: "GRAPHIC LCD DISPLAY (optional)" },
    { icon: "download", text: "UP TO 10,000 PLUs" },
    { icon: "people-fill", text: "UP TO 20 VENDORS" },
    { icon: "ethernet", text: "ETHERNET TCP/IP" },
    { icon: "usb-drive", text: "USB OPTIONAL" },
    { icon: "wifi", text: "Wi-Fi OPTIONAL" },
    { icon: "battery-charging", text: "INTERNAL RECHARGEABLE BATTERY (opt.)" },
  ];

  const [activeTab, setActiveTab] = useState('MODELS');
  
  // Define a constant for the active blue color
  const activeColor = '#3ec63e';
  const inactiveColor = '#9E9E9E';
  
  // Tabs with their default colors - we'll override these based on which tab is active
  const tabs = [
    { id: 'PRODUCT FEATURES', defaultColor: activeColor },
    { id: 'PARAMETERS', defaultColor: inactiveColor},
  ];
  
  // Function to get the current color for a tab
  const getTabColor = (tabId) => {
    // When a tab is active, always use the active blue color
    // When inactive, use the inactive gray color
    return tabId === activeTab ? activeColor : inactiveColor;
  };
  
  

  // Information section bullet points
  const informationPoints = [
      "Water-proof, moisture-proof, insect-resistant. Avoid bugs crawl into the machine, and all kinds of malfunctions causes such as wet.",
      "Exquisite ,with drawable printer,easy to take out paper and replace paper, simple and convenient operation.",
      "Support PLU updating on line and editing, ensure the item all the latest information.",
      "Storage capacity up to 10000 pieces commodities and support 224 hotkeys. Set menu shortcuts, through the PC software can adjust the hotkey sequence and print it out.",
      "Each item could choose any tag from independently. Multiple barcode optional,such as 8 bit,13 bit, and 18 bit.",
      "Can set up different types and information, etc according to different items. It advantageous to the commodity classification management.",
      "Support Labels and barcode rotated 90 degrees, or 270 degrees printing.",
      "Support to be connected by Ethernet interface, Software can be upgraded online, to meet customer's special demand.",
      "More rich label content. can print production date, date of packaging, fresh date, expiration date, Select it according to clients requirements.",
      "Searching products quickly by product No.",
      "Support discount schedule, discount period setting.",
      "Support for multiple foreign languages, labels, such as background, the name of the item etc.",
      "Support double screen dot matrix display, easy to promote products.",
      "Support receipt paper and label paper printing.",
      "Dual-motor design, printing more efficient and stable."
  ];

  // Function to render content based on active tab
  const renderTabContent = () => {
    switch(activeTab) {
      case 'PRODUCT FEATURES':
        return (
          <div className="p-4">
            <h4 style={{fontFamily: "'Montserrat', serif", marginBottom: "20px"}}>Main features</h4>
            <ul className="information-list">
              {informationPoints.map((point, index) => (
                <li key={index} style={{fontFamily: "'Poppins', serif", fontSize: "14px", marginBottom: "15px"}}>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        );
      case 'PARAMETERS':
        return (
          <div className="container mt-4">
      <h3 className="mb-4 text-underline" style={{fontFamily:"Poppins", fontSize:"19px"}}>Product Specifications</h3>
      <Table striped bordered hover responsive 
      style={{fontFamily:"sans-serif", fontSize:"14px"}}
      >
        <thead>
          <tr>
            <th>Category</th>
            <th>Specification</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {/* Capacity Section */}
          <tr>
            <td rowSpan="4">Capacity</td>
            <td>Max capacity</td>
            <td>6kg/15kg | 15kg/30kg</td>
          </tr>
          <tr>
            <td>Min capacity</td>
            <td>40g | 100g</td>
          </tr>
          <tr>
            <td>Interval</td>
            <td>2/5g | 5/10g</td>
          </tr>
          <tr>
            <td>Accuracy class</td>
            <td>III</td>
          </tr>
          
          {/* Basic Section */}
          <tr>
            <td rowSpan="10">Basic</td>
            <td>COG</td>
            <td>LCD 256X32</td>
          </tr>
          <tr>
            <td>SDRAM</td>
            <td>8MB</td>
          </tr>
          <tr>
            <td>FLASH</td>
            <td>16MB</td>
          </tr>
          <tr>
            <td>Ethernet</td>
            <td>1 x RJ45</td>
          </tr>
          <tr>
            <td>Serial</td>
            <td>1 x RS232</td>
          </tr>
          <tr>
            <td>Power source</td>
            <td>1 x AC Jack</td>
          </tr>
          <tr>
            <td>Input</td>
            <td>AC100V-240V 50/60Hz 1.5A</td>
          </tr>
          <tr>
            <td>Buttons</td>
            <td>Hotkeys: 112*2; Preset keys: 28</td>
          </tr>
          <tr>
            <td>Notification</td>
            <td>Buzzer</td>
          </tr>
          <tr>
            <td>Dimension</td>
            <td>433(L) x 372(W) x 506(H)mm</td>
          </tr>
          
          {/* Communication Section */}
          <tr>
            <td rowSpan="2">Communication</td>
            <td>Ethernet</td>
            <td>TCP/IP 100M</td>
          </tr>
          <tr>
            <td>Wi-Fi(Optional)</td>
            <td>IEEE 802.11 b/g/n, 2.4GHz</td>
          </tr>
          
          {/* Printer Section */}
          <tr>
            <td rowSpan="6">Printer</td>
            <td>Printing</td>
            <td>Thermal print</td>
          </tr>
          <tr>
            <td>Print width</td>
            <td>MAX 56mm</td>
          </tr>
          <tr>
            <td>Print speed</td>
            <td>90 m/s</td>
          </tr>
          <tr>
            <td>Printer resolution</td>
            <td>203 DPI</td>
          </tr>
          <tr>
            <td>Paper out</td>
            <td>Auto peel off</td>
          </tr>
          <tr>
            <td>Barcode format</td>
            <td>2/5 interleaved, 128, EAN13, GS128</td>
          </tr>
          
          {/* Reliability requirements Section */}
          <tr>
            <td rowSpan="2">Reliability requirements</td>
            <td>Certification</td>
            <td>OIML, CE, Type evaluation, NTEP: RLS1000 (RLS1200)</td>
          </tr>
          <tr>
            <td>Implementation standards</td>
            <td>GB/T 7722-2020, OIML R 76-1(2006) and EN 45501: 2015</td>
          </tr>
          
          {/* Operation environment Section */}
          <tr>
            <td rowSpan="4">Operation environment</td>
            <td>Operating temperature</td>
            <td>0°C ~ +40°C</td>
          </tr>
          <tr>
            <td>Operating humidity</td>
            <td>20% ~ 85%</td>
          </tr>
          <tr>
            <td>Storage temperature</td>
            <td>-20°C ~ +60°C</td>
          </tr>
          <tr>
            <td>Operating temperature</td>
            <td>5% ~ 95%</td>
          </tr>
          
          {/* Packaging material Section */}
          <tr>
            <td>Packaging material</td>
            <td>Standard</td>
            <td>■Kraft paper ■Styrofoam ■Power cable ■Scale pan ■Warranty card ■Certificate ■User manual</td>
          </tr>
        </tbody>
      </Table>
    </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className='text-center'>
        <h3 style={{fontFamily: "'Montserrat', serif"}}>RLS1000/RLS1100 Barcode Label Weighing Scale</h3>
        <p className='ml-5 mr-5 mt-4' style={{fontFamily: "'Poppins', serif", fontSize:"15px"}}>Price computing electronic scales with receipt or label printer, and PC connection. Easy to use retail electronic scales with excellent features.</p>
      </div>
      
      <Container className="my-5">
        <Row>
          {/* Left Division - Image Carousel */}
          <Col md={6} className="mb-4 mb-md-0">
            <div className="border rounded p-3 h-100">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img1}
                    alt="First slide"
                  />
                  <Carousel.Caption>
                    <h5>First slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img2}
                    alt="Second slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>Second slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img3}
                    alt="Third slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>Third slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img4}
                    alt="Third slide"
                  />
                  
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>

          {/* Right Division - Icons Display */}
          <Col md={6}>
            <div className="border rounded p-3 h-100">
              <h4 className="mb-3">Features</h4>
              <ul style={{fontFamily:"Poppins" }}>
                <li className='mb-3' style={{fontSize:"14px"}}>
                  Water-proof, moisture-proof, insect-resistant. Avoid bugs crawl into the machine, and all kinds of malfunctions causes such as wet.
                </li>
                <li className='mb-3' style={{fontSize:"14px"}}>
                Exquisite ,with drawable printer,easy to take out paper and replace paper, simple and convenient operation.
                </li>
                <li className='mb-3' style={{fontSize:"14px"}}>
                Support PLU updating on line and editing, ensure the item all the latest information.
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid className="p-0">
        {/* Custom Tabs */}
        <div className="position-relative">
          <Nav className="custom-tabs d-flex">
            {tabs.map((tab) => (
              <Nav.Item 
                key={tab.id} 
                className="tab-item" 
                style={{ 
                  backgroundColor: getTabColor(tab.id)
                }}
                onClick={() => setActiveTab(tab.id)}
              >
                <Nav.Link 
                  className={`py-3 px-4 text-white fw-bold border-0 ${activeTab === tab.id ? 'active' : ''}`}
                >
                  {tab.id}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        {/* Tab Content Area */}
        <div className="bg-white p-4 border">
          {renderTabContent()}
        </div>

        {/* Custom CSS */}
        <style>{`
          .custom-tabs {
            display: flex;
            overflow-x: auto;
            position: relative;
          }

          .tab-item {
            position: relative;
            /* This creates a shape with straight left edge and slanted right edge */
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
            margin-right: -20px; /* Negative margin creates the overlap effect */
            z-index: 1;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          /* Each subsequent tab needs higher z-index to properly overlap */
          .tab-item:nth-child(1) { z-index: 5; }
          .tab-item:nth-child(2) { z-index: 4; }
          .tab-item:nth-child(3) { z-index: 3; }
          .tab-item:nth-child(4) { z-index: 2; }
          .tab-item:nth-child(5) { z-index: 1; }

          /* Last tab can have a different shape if needed */
          .tab-item:last-child {
            margin-right: 0;
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
          }

          .tab-item .nav-link {
            background: transparent !important;
            border-radius: 0;
            padding: 15px 40px; /* Adjust padding as needed */
          }

          .tab-item .nav-link.active {
            font-weight: bold;
          }

          .information-list {
            padding-left: 25px;
          }
          
          .information-list li {
            position: relative;
            list-style-type: none;
            padding-left: 25px;
            margin-bottom: 15px;
          }
          
          .information-list li:before {
            content: "•";
            position: absolute;
            left: 0;
            color: #3ec63e;
            font-size: 24px;
            line-height: 1;
          }
          
          .circular-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #f8f9fa;
            border: 2px solid #0d6efd;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        `}</style>
      </Container>
    </div>
  )
}

export default Rongta